import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
// import { useDispatch } from 'react-redux';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
// import { push } from 'connected-react-router';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import { AnyObject } from 'final-form';
import ProjectBilling from 'src/models/projectSettings/ProjectBilling';
import InvoiceTypeList from './InvoiceTypeList';
import InvoiceType from 'src/models/InvoiceType';

const SettingsProjectBilling = () => {
    const { register, handleSubmit, errors, control, reset, getValues, setValue } = useForm();
    // const dispatch = useDispatch();
    const { get, response, post, put } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [formData, setFormData] = useState(null);

    const [trackingEnable, setTrackingEnable] = useState(false);
    const [AFEwarning, setAFEwarning] = useState(false);
    const [projectBillingData, setProjectBillingData] = useState<ProjectBilling>(undefined);
    const [invoiceTypeList, setInvoiceTypeList] = useState<InvoiceType[]>([]);
    const [selectedInvoiceTypes, setSelectedInvoiceTypes] = useState<InvoiceType[]>([]);

    useEffect(() => {
        getInvoiceTypes();
        getProjectBillingData();
    }, []);

    useEffect(() => {
        prepFormData();
    }, [projectBillingData]);

    useEffect(() => {
        reset(formData);
    }, [formData]);

    const getProjectBillingData = async () => {
        const result: ProjectBilling = await get(`/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/project-billing`);

        if (response.ok) {
            console.log('Project Billing Data: ', result);
            setSelectedInvoiceTypes(result.invoiceTypes);
            setProjectBillingData(result);
        }
    };

    const getInvoiceTypes = async () => {
        const result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/invoice/invoice-types`);

        if (response.ok) {
            setInvoiceTypeList(result);
        }
    };

    const prepFormData = () => {
        let newData: ProjectBilling = {
            id: projectBillingData ? projectBillingData?.id : 0,
            dayRate: projectBillingData ? projectBillingData?.dayRate : 0,
            mileageRate: projectBillingData ? projectBillingData?.mileageRate : 0,
            invoiceFormat: projectBillingData ? projectBillingData?.invoiceFormat : '',
            billByMethod: projectBillingData ? projectBillingData?.billByMethod : '',
            invoicePeriod: projectBillingData ? projectBillingData?.invoicePeriod : '',
            totalAFE: projectBillingData ? projectBillingData?.totalAFE : 0,
            totalAFEused: projectBillingData ? projectBillingData?.totalAFEused : 0,
            invoiceSupplement: projectBillingData ? projectBillingData?.invoiceSupplement : '',
            mealReceiptsRequired: projectBillingData ? projectBillingData?.mealReceiptsRequired : false,
            breakdownOfficeExpenses: projectBillingData ? projectBillingData?.breakdownOfficeExpenses : true,
            chargeBackupPersonnel: projectBillingData ? projectBillingData?.chargeBackupPersonnel : true,
            chargeOfficeExpenses: projectBillingData ? projectBillingData?.chargeOfficeExpenses : false,
            billToOtherProject: projectBillingData ? projectBillingData?.billToOtherProject : true,
            enterClientAFENoOnTimeSheet: projectBillingData ? projectBillingData?.enterClientAFENoOnTimeSheet : true,
            doNotExceedProject: projectBillingData ? projectBillingData?.doNotExceedProject : false,
            doNotBillServicesOrExpenses: projectBillingData ? projectBillingData?.doNotBillServicesOrExpenses : false,
            clientLMEmailOnInvoice: projectBillingData ? projectBillingData?.clientLMEmailOnInvoice : false,
            printPreparedDate: projectBillingData ? projectBillingData?.printPreparedDate : false,
            chargeBackupOfficeAtCost: projectBillingData ? projectBillingData?.chargeBackupOfficeAtCost : false,
            clientsForm: projectBillingData ? projectBillingData?.clientsForm : false,
            dlcForm: projectBillingData ? projectBillingData?.dlcForm : false,
            recap: projectBillingData ? projectBillingData?.recap : false,
            invoiceDiscountBonusPercent: projectBillingData ? projectBillingData?.invoiceDiscountBonusPercent : false,
            billingFrequency: projectBillingData ? projectBillingData?.billingFrequency : false,
            enterClientProjectNoOnTimeSheet: projectBillingData ? projectBillingData?.enterClientProjectNoOnTimeSheet : false,
            enterClientProjectNameOnTimeSheet: projectBillingData ? projectBillingData?.enterClientProjectNameOnTimeSheet : false,
            enterClientAccountNoOnTimeSheet: projectBillingData ? projectBillingData?.enterClientAccountNoOnTimeSheet : false,
            arInvoiceGrouping: projectBillingData ? projectBillingData?.arInvoiceGrouping : false,
            mileageDestinationRequired: projectBillingData ? projectBillingData?.mileageDestinationRequired : false,
            unitTaskEntryRequired: projectBillingData ? projectBillingData?.unitTaskEntryRequired : false,
            turnkeyBilling: projectBillingData ? projectBillingData?.turnkeyBilling : false,
            doNotRoundDaysOnBackupOffice: projectBillingData ? projectBillingData?.doNotRoundDaysOnBackupOffice : false,
            printBillingPersonnelNameOnInvoice: projectBillingData ? projectBillingData?.printBillingPersonnelNameOnInvoice : false,
            printAFEStatusOnInvoiceCoverLetter: projectBillingData ? projectBillingData?.printAFEStatusOnInvoiceCoverLetter : false,
            totalAFEWarningPercentage: projectBillingData ? projectBillingData?.totalAFEWarningPercentage : false,
            billingInstruction: projectBillingData ? projectBillingData?.billingInstruction : '',
            invoiceTypes: projectBillingData ? projectBillingData?.invoiceTypes : [],
            removeInvoiceTypeIds: [],
        };

        if (newData.doNotExceedProject) {
            setTrackingEnable(newData.doNotExceedProject);
        }

        setFormData(newData);
    };

    const createRecord = async (data: ProjectBilling) => {
        const result = await post(`/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/project-billing`, data);

        if (response.ok) {
            console.log('Successfully created a project billing record', result);
        }
    };

    const updateRecord = async (data: ProjectBilling) => {
        const result = await put(`/v1.0/clients/${appContext.clientNumber}/Projects/${appContext.projectNumber}/project-billing`, data);

        if (response.ok) {
            console.log('PB - result', result);
            setSelectedInvoiceTypes([]);
            getProjectBillingData();
        }
    };

    const enableAFEpercentTracking = (e: AnyObject) => {
        setTrackingEnable(e.target.checked);
    };
    const displayWarning = () => {
        setAFEwarning(true);
    };

    const formatValues = (values: AnyObject) => {
        let newValues: ProjectBilling = {
            id: 0,
            dayRate: 0,
            mileageRate: 0,
            invoiceFormat: '',
            billByMethod: '',
            invoicePeriod: '',
            totalAFE: 0,
            totalAFEused: 0,
            invoiceSupplement: '',
            mealReceiptsRequired: false,
            breakdownOfficeExpenses: false,
            chargeBackupPersonnel: false,
            chargeOfficeExpenses: false,
            doNotBillServicesOrExpenses: false,
            clientLMEmailOnInvoice: false,
            billToOtherProject: false,
            printPreparedDate: false,
            chargeBackupOfficeAtCost: false,
            clientsForm: false,
            dlcForm: false,
            recap: false,
            invoiceDiscountBonusPercent: false,
            billingFrequency: false,
            enterClientAFENoOnTimeSheet: false,
            enterClientProjectNoOnTimeSheet: false,
            enterClientProjectNameOnTimeSheet: false,
            enterClientAccountNoOnTimeSheet: false,
            arInvoiceGrouping: false,
            mileageDestinationRequired: false,
            unitTaskEntryRequired: false,
            turnkeyBilling: false,
            doNotRoundDaysOnBackupOffice: false,
            printBillingPersonnelNameOnInvoice: false,
            printAFEStatusOnInvoiceCoverLetter: false,
            doNotExceedProject: false,
            totalAFEWarningPercentage: false,
            billingInstruction: '',
        };

        newValues.id = projectBillingData?.id ? parseInt(projectBillingData?.id + '', 10) : 0;
        newValues.dayRate = values.dayRate ? parseFloat(values.dayRate + '') : 0;
        newValues.mileageRate = values.mileageRate ? parseInt(values.mileageRate + '', 10) : 0;
        newValues.totalAFE = values.totalAFE ? parseFloat(values.totalAFE + '') : 0;
        newValues.totalAFEused = values.totalAFEused ? parseFloat(values.totalAFEused + '') : 0;
        newValues.invoiceFormat = values.invoiceFormat ? values.invoiceFormat : '';
        newValues.invoiceSupplement = values.invoiceSupplement ? values.invoiceSupplement : '';
        newValues.billByMethod = values.billByMethod ? values.billByMethod : '';
        newValues.invoicePeriod = values.invoicePeriod ? values.invoicePeriod : '';
        newValues.mealReceiptsRequired = !!values.mealReceiptsRequired ? values.mealReceiptsRequired : null;
        newValues.breakdownOfficeExpenses = !!values.breakdownOfficeExpenses ? values.breakdownOfficeExpenses : null;
        newValues.chargeBackupOfficeAtCost = !!values.chargeBackupOfficeAtCost ? values.chargeBackupOfficeAtCost : null;
        newValues.chargeBackupPersonnel = !!values.chargeBackupPersonnel ? values.chargeBackupPersonnel : null;
        newValues.chargeOfficeExpenses = !!values.chargeOfficeExpenses ? values.chargeOfficeExpenses : null;
        newValues.doNotBillServicesOrExpenses = !!values.doNotBillServicesOrExpenses ? values.doNotBillServicesOrExpenses : null;
        newValues.clientLMEmailOnInvoice = !!values.clientLMEmailOnInvoice ? values.clientLMEmailOnInvoice : null;
        newValues.billToOtherProject = !!values.billToOtherProject ? values.billToOtherProject : null;
        newValues.printPreparedDate = !!values.printPreparedDate ? values.printPreparedDate : null;
        newValues.clientsForm = !!values.clientsForm ? values.clientsForm : null;
        newValues.dlcForm = !!values.dlcForm ? values.dlcForm : null;
        newValues.recap = !!values.recap ? values.recap : null;
        newValues.invoiceDiscountBonusPercent = !!values.invoiceDiscountBonusPercent ? values.invoiceDiscountBonusPercent : null;
        newValues.billingFrequency = !!values.billingFrequency ? values.billingFrequency : null;
        newValues.enterClientAFENoOnTimeSheet = !!values.enterClientAFENoOnTimeSheet ? values.enterClientAFENoOnTimeSheet : null;
        newValues.enterClientProjectNoOnTimeSheet = !!values.enterClientProjectNoOnTimeSheet ? values.enterClientProjectNoOnTimeSheet : null;
        newValues.enterClientProjectNameOnTimeSheet = !!values.enterClientProjectNameOnTimeSheet ? values.enterClientProjectNameOnTimeSheet : null;
        newValues.enterClientAccountNoOnTimeSheet = !!values.enterClientAccountNoOnTimeSheet ? values.enterClientAccountNoOnTimeSheet : null;
        newValues.arInvoiceGrouping = !!values.arInvoiceGrouping ? values.arInvoiceGrouping : null;
        newValues.mileageDestinationRequired = !!values.mileageDestinationRequired ? values.mileageDestinationRequired : null;
        newValues.unitTaskEntryRequired = !!values.unitTaskEntryRequired ? values.unitTaskEntryRequired : null;
        newValues.turnkeyBilling = !!values.turnkeyBilling ? values.turnkeyBilling : null;
        newValues.doNotRoundDaysOnBackupOffice = !!values.doNotRoundDaysOnBackupOffice ? values.doNotRoundDaysOnBackupOffice : null;
        newValues.printBillingPersonnelNameOnInvoice = !!values.printBillingPersonnelNameOnInvoice ? values.printBillingPersonnelNameOnInvoice : null;
        newValues.printAFEStatusOnInvoiceCoverLetter = !!values.printAFEStatusOnInvoiceCoverLetter ? values.printAFEStatusOnInvoiceCoverLetter : null;
        newValues.doNotExceedProject = !!values.doNotExceedProject ? values.doNotExceedProject : null;
        newValues.totalAFEWarningPercentage = !!values.totalAFEWarningPercentage ? values.totalAFEWarningPercentage : null;
        newValues.billingInstruction = values.billingInstruction ? values.billingInstruction : '';

        newValues.invoiceTypes = [];
        newValues.removeInvoiceTypeIds = [];
        if (projectBillingData.invoiceTypes?.length > 0) {
            projectBillingData.invoiceTypes?.forEach((invoiceType: InvoiceType) => {
                if (
                    !values.invoiceTypes ||
                    values.invoiceTypes?.indexOf(values.invoiceTypes?.find((it: { id: string }) => parseInt(it.id, 10) === invoiceType.id)) <= -1
                ) {
                    newValues.removeInvoiceTypeIds.push(invoiceType.id);
                }
            });
            values.invoiceTypes?.forEach((invoiceType: InvoiceType) => {
                if (
                    projectBillingData.invoiceTypes?.indexOf(
                        projectBillingData.invoiceTypes?.find((pit) => pit.id === parseInt(invoiceType.id + '', 10))
                    ) <= -1
                ) {
                    newValues.invoiceTypes?.push(invoiceTypeList.find((it) => it.id === parseInt(invoiceType.id + '', 10)));
                }
            });
        } else if (values.invoiceTypes?.length > 0) {
            newValues.invoiceTypes = values.invoiceTypes?.map((fit: InvoiceType) => {
                return invoiceTypeList.find((it) => it.id === parseInt(fit.id + '', 10));
            });
        }

        if (newValues.doNotExceedProject === true) {
            setTrackingEnable(true);
        }

        if (trackingEnable === true) {
            newValues.totalAFEused = AFEcontrolCheck(values);
            displayWarning();
        }

        return newValues;
    };

    const AFEcontrolCheck = (values: AnyObject) => {
        if (formData.totalAFE !== 0 || formData.totalAFE !== undefined) {
            let newDayRate = parseInt(values.dayRate + '', 10);
            let newMileageRate = parseInt(values.mileageRate + '', 10);

            let percentage = Math.round(((newDayRate + newMileageRate) / values.totalAFE) * 100 * 10) / 10;

            return percentage;
        }

        return 0;
    };

    const onSubmit = (values: AnyObject) => {
        let newValues = formatValues(values);

        if (!projectBillingData?.id) {
            createRecord(newValues);
        } else {
            updateRecord(newValues);
        }
    };

    const resetInvoiceTypeValues = (index: number) => {
        let rep = getValues().invoiceTypes;
        let newList = [...rep];

        for (let i = index; i < rep.length - 1; i++) {
            setValue(`invoiceTypes[${i}].id`, rep[i + 1].id);
        }
        setValue(`invoiceTypes[${newList.length - 1}].id`, 0);
        newList.splice(newList.length - 1, 1);

        setSelectedInvoiceTypes(newList);
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <FormRow style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <RHFInputBox
                            bodyStyle={{ width: '150px' }}
                            name="dayRate"
                            label="Default Bill Rate"
                            register={register}
                            errors={errors}
                            type="number"
                        />
                        <RHFInputBox
                            bodyStyle={{ width: '150px' }}
                            name="mileageRate"
                            label="Mileage Rate"
                            register={register}
                            errors={errors}
                            type="number"
                        />
                        <RHFInputBox bodyStyle={{ width: '150px' }} name="invoiceFormat" label="Invoice Format" register={register} errors={errors} />
                        <RHFInputBox bodyStyle={{ width: '150px' }} name="billByMethod" label="Bill By Method" register={register} errors={errors} />
                        <RHFInputBox bodyStyle={{ width: '150px' }} name="invoicePeriod" label="Invoice Period" register={register} errors={errors} />
                        <RHFInputBox bodyStyle={{ width: '150px' }} name="totalAFE" label="Total AFE" register={register} errors={errors} />
                        {!AFEwarning ? (
                            <></>
                        ) : (
                            <RHFInputBox
                                bodyStyle={{ width: '150px' }}
                                name="totalAFEused"
                                label="Total AFE Used (%)"
                                register={register}
                                errors={errors}
                            />
                        )}
                        <RHFInputBox
                            bodyStyle={{ width: '150px' }}
                            name="invoiceSupplement"
                            label="Invoice Supplement"
                            register={register}
                            errors={errors}
                        />
                    </FormRow>

                    <FormRow>
                        <RHFCheckbox name="mealReceiptsRequired" label="Meal Receipts Required?" register={register} errors={errors} />
                        <RHFCheckbox name="breakdownOfficeExpenses" label="Breakdown Office Expenses?" register={register} errors={errors} />
                        <RHFCheckbox name="chargeBackupPersonnel" label="Charge Backup Personnel?" register={register} errors={errors} />
                        <RHFCheckbox name="chargeOfficeExpenses" label="Charge Office Expenses?" register={register} errors={errors} />
                        <RHFCheckbox
                            name="doNotBillServicesOrExpenses"
                            label="Do Not Bill Services Or Expenses?"
                            register={register}
                            errors={errors}
                        />
                        {/* <RHFCheckbox name="clientLMEmailOnInvoice" label="Client LM E-Mail on Invoice?" register={register} errors={errors} /> */}
                        <RHFCheckbox name="printPreparedDate" label="Print Prepared Date?" register={register} errors={errors} />
                        <RHFCheckbox name="chargeBackupOfficeAtCost" label="Charge Backup/Office at Cost?" register={register} errors={errors} />
                    </FormRow>

                    <div>
                        <h3>Required Time Sheets</h3>
                        <RHFCheckbox name="clientsForm" label="Client's Form" register={register} errors={errors} />
                        <RHFCheckbox name="dlcForm" label="DLC Form" register={register} errors={errors} />
                        <RHFCheckbox name="recap" label="Recap" register={register} errors={errors} />
                    </div>

                    <FormRow>
                        <RHFCheckbox name="invoiceDiscountBonusPercent" label="Invoice Discount/Bonus Percent" register={register} errors={errors} />
                        <RHFCheckbox name="billingFrequency" label="Billing Frequency" register={register} errors={errors} />
                    </FormRow>

                    <RHFLegend title="Invoice Types" />
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginRight: '1rem', borderRight: '1px solid grey', paddingRight: '.5rem', width: '80%' }}>
                            <InvoiceTypeList
                                typeList={invoiceTypeList}
                                selectedTypeList={selectedInvoiceTypes}
                                getValues={() => getValues()}
                                resetValues={(i: number) => resetInvoiceTypeValues(i)}
                                register={register}
                                errors={errors}
                                control={control}
                            />
                            {/* <FormRow>
                                <RHFInputBox name="invoiceTypeNumber" label="Number" register={register} errors={errors} />
                                <RHFInputBox name="invoiceTypeDescription" label="Invoice Description" register={register} errors={errors} />
                                <RHFInputBox name="invoiceTypeAccount" label="Invoice Account" register={register} errors={errors} />
                            </FormRow>

                            <FormRow style={{ marginTop: '.5rem' }}>
                                <Button text="Add" />
                                <Button text="Delete" />
                                <Button text="Edit" />
                            </FormRow> */}
                        </div>
                        <div>
                            <FormRow>
                                <RHFInputBox name="invoiceFactor" label="Invoice Factor" register={register} errors={errors} />
                                <RHFInputBox name="backupOfficeRate" label="Backup Office Rate" register={register} errors={errors} />
                                <RHFInputBox name="backupOfficePercent" label="Backup Office Percent" register={register} errors={errors} />
                            </FormRow>

                            <FormRow style={{ marginTop: '.5rem' }}>
                                <Button text="Billing History" />
                                <Button text="Multi Billing History" />
                            </FormRow>

                            <FormRow style={{ marginTop: '.5rem' }}>
                                <Button text="Edit Mul. Billing" />
                                <Button text="Instruction History" />
                            </FormRow>
                        </div>
                    </div>

                    <FormRow>
                        <RHFTextArea name="billingInstruction" label="Billing Instructions" register={register} errors={errors} />
                    </FormRow>

                    <RHFLegend title="Additional Billing Options" />

                    <FormRow>
                        <RHFCheckbox name="billToOtherProject" label="Bill To Other Project?" register={register} errors={errors} />
                        <RHFCheckbox
                            name="enterClientProjectNoOnTimeSheet"
                            label="Enter Client Project No on Time Sheet?"
                            register={register}
                            errors={errors}
                        />
                        <RHFCheckbox
                            name="enterClientAFENoOnTimeSheet"
                            label="Enter Client AFE No. on Time Sheet?"
                            register={register}
                            errors={errors}
                        />
                    </FormRow>
                    <FormRow>
                        <RHFCheckbox name="arInvoiceGrouping" label="A/R Invoice Grouping?" register={register} errors={errors} />
                        <RHFCheckbox name="mileageDestinationRequired" label="Mileage Destination Required?" register={register} errors={errors} />
                        <RHFCheckbox name="unitTaskEntryRequired" label="Unit/Task Entry Required?" register={register} errors={errors} />
                    </FormRow>
                    <FormRow>
                        <RHFCheckbox name="turnkeyBilling" label="Turnkey Billing?" register={register} errors={errors} />
                        <RHFCheckbox
                            name="doNotRoundDaysOnBackupOffice"
                            label="Do Not Round Days on Backup/Office"
                            register={register}
                            errors={errors}
                        />
                        <RHFCheckbox
                            name="printBillingPersonnelNameOnInvoice"
                            label="Print Billing Personnel Name on invoice?"
                            register={register}
                            errors={errors}
                        />
                    </FormRow>
                    <FormRow style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <RHFCheckbox
                            bodyStyle={{ width: '210px' }}
                            name="doNotExceedProject"
                            label="Do Not Exceed Project?"
                            register={register}
                            errors={errors}
                            onClick={enableAFEpercentTracking}
                        />

                        {!!trackingEnable && (
                            <RHFCheckbox
                                bodyStyle={{ width: '210px' }}
                                name="totalAFEWarningPercentage"
                                label="Total AFE Warning Percentage"
                                register={register}
                                errors={errors}
                            />
                        )}

                        <RHFCheckbox
                            bodyStyle={{ width: '340px' }}
                            name="printAFEStatusOnInvoiceCoverLetter"
                            label="Print AFE Status on Invoice / Cover Letter?"
                            register={register}
                            errors={errors}
                        />
                    </FormRow>
                    <FormRow style={{ display: 'flex' }}>
                        <RHFCheckbox
                            bodyStyle={{ width: '340px' }}
                            name="enterClientProjectNameOnTimeSheet"
                            label="Enter Client Project Name on Time Sheet?"
                            register={register}
                            errors={errors}
                        />
                        <RHFCheckbox
                            bodyStyle={{ width: '300px' }}
                            name="enterClientAccountNoOnTimeSheet"
                            label="Enter Client Account No. on Time Sheet?"
                            register={register}
                            errors={errors}
                        />
                    </FormRow>
                </div>

                <div>
                    <Button text="Submit" intent="primary" type="submit" />
                </div>
            </form>
        </div>
    );
};

export default SettingsProjectBilling;



// WEBPACK FOOTER //
// ./src/components/project/sections/SettingsProjectBilling.tsx